document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-section-id]").forEach((section) => {
    const media = section.querySelector("[data-hero-media]");
    if (!media) return;

    const img = media.querySelector(".hero__image");
    const play = media.querySelector(".hero__play");
    const iframe = media.querySelector(".hero__video");
    if (!play || !iframe) return;

    // ensure iframe permissions
    const allow = iframe.getAttribute("allow") || "";
    if (!allow.includes("autoplay")) {
      iframe.setAttribute(
        "allow",
        (allow ? allow + "; " : "") +
          "autoplay; encrypted-media; fullscreen; picture-in-picture"
      );
    }

    // spinner element (create if missing)
    let spinner = media.querySelector(".hero__spinner");
    if (!spinner) {
      spinner = document.createElement("div");
      spinner.className = "hero__spinner";
      spinner.setAttribute("aria-hidden", "true");
      media.appendChild(spinner);
    }

    // --- YouTube/Vimeo embed builders ---
    const raw = (iframe.getAttribute("data-video-url") || "").trim();

    const buildYouTubeEmbed = (url) => {
      let id = "";
      if (/youtu\.be\//.test(url)) {
        id = url.split("youtu.be/")[1].split(/[?&#]/)[0];
      } else if (/youtube\.com\/watch\?v=/.test(url)) {
        id = url.split("v=")[1].split("&")[0];
      } else if (/youtube\.com\/embed\//.test(url)) {
        id = url.split("/embed/")[1].split(/[?&#]/)[0];
      } else {
        const m = url.match(/([a-zA-Z0-9_-]{11})(?![a-zA-Z0-9_-])/);
        if (m) id = m[1];
      }
      if (!id) return null;
      const origin = encodeURIComponent(window.location.origin);
      // enablejsapi is required so we can listen for state via postMessage
      return `https://www.youtube.com/embed/${id}?autoplay=1&rel=0&playsinline=1&mute=0&enablejsapi=1&origin=${origin}`;
    };

    const buildVimeoEmbed = (url) => {
      const m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (!m) return null;
      return `https://player.vimeo.com/video/${m[1]}?autoplay=1&muted=0`;
    };

    const getEmbedUrl = (url) => {
      if (/youtube\.com|youtu\.be/.test(url)) return buildYouTubeEmbed(url);
      if (/vimeo\.com/.test(url)) return buildVimeoEmbed(url);
      return null;
    };

    // --- YouTube player state listener (via postMessage) ---
    const onYTMessage = (evt) => {
      // Only care about messages that look like YT player events
      if (!evt || typeof evt.data !== "string") return;
      let data;
      try {
        data = JSON.parse(evt.data);
      } catch {
        return;
      }

      // We only need state changes
      if (data && data.event === "onStateChange") {
        // 1 = playing, 3 = buffering, 2 = paused, 0 = ended
        if (data.info === 1) {
          // playing → hide spinner
          spinner.style.display = "none";
        }
      }
    };
    window.addEventListener("message", onYTMessage);

    const sendYT = (frame, payload) => {
      try {
        frame.contentWindow?.postMessage(JSON.stringify(payload), "*");
      } catch (_) {}
    };

    // Register to receive state changes once the player is ready
    const primeYTListener = (frame) => {
      // Tell the player we want events
      sendYT(frame, { event: "listening", id: "hero-player" });
      // Subscribe to onStateChange
      sendYT(frame, {
        event: "command",
        func: "addEventListener",
        args: ["onStateChange"],
      });
    };

    play.addEventListener("click", () => {
      play.style.display = "none";
      if (img) img.style.opacity = 0;

      // show spinner immediately
      spinner.style.display = "grid";

      const embedUrl = getEmbedUrl(raw);
      if (!embedUrl) {
        console.error("[Hero Video] Invalid data-video-url:", raw);
        spinner.style.display = "none";
        return;
      }

      // Force a clean reload
      iframe.removeAttribute("src");
      requestAnimationFrame(() => {
        iframe.setAttribute("src", embedUrl);
        iframe.style.display = "block";

        // prime listener and try playing
        primeYTListener(iframe);

        // spam a few play commands to overcome timing of player readiness
        let tries = 0;
        const playKick = setInterval(() => {
          tries++;
          sendYT(iframe, { event: "command", func: "playVideo", args: [] });
          if (tries >= 10) clearInterval(playKick);
        }, 150);

        // hard fallback: in case no state event ever arrives, hide spinner after 5s
        setTimeout(() => {
          spinner.style.display = "none";
        }, 1000);
      });
    });
  });
});
